export default {
    page_title: "Kevi | Clients Report",
    title: "Clients Report",
    active_clients_description:
        "Total clients with at least one purchase in the {0} days before the beginning of each month",
    headings: {
        active_clients: "Active clients",
        retention_rate: "Retention rate",
        clients_by_action: "Clients by action",
    },
    actions: {
        retained: "Retained (< {0}d)",
        reactivated: "Reactivated (between {0}d and {1}d)",
        recovered: "Recovered (> {0}d)",
        new_first_purchase: "New (1st Purchase)",
    },
    filters: {
        client_segment: "Segment",
    },
};
